import { render, staticRenderFns } from "./StageCrud.vue?vue&type=template&id=b998d8d6"
import script from "./StageCrud.vue?vue&type=script&lang=js"
export * from "./StageCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports